export default __webpack_public_path__ + "static/media/rec.1c27dfd4.jpg";